import { API_BASE_URL } from '../config';
import { Session } from '../components/utils/session';

let cachedUsers = null;
let inflightRequest = null;

export async function fetchUsersListCached(options = {}) {
  if (cachedUsers) return cachedUsers;

  if (inflightRequest) return inflightRequest;

  const token = Session.getToken();
  if (!token) return [];

  inflightRequest = fetch(`${API_BASE_URL}/api/Members/Users_List`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    signal: options.signal,
  })
    .then((res) => (res.ok ? res.json() : []))
    .then((data) => {
      cachedUsers = (Array.isArray(data) ? data : []).slice().sort((a, b) => {
        const nameA = String(a.userName ?? a.UserName ?? '');
        const nameB = String(b.userName ?? b.UserName ?? '');
        return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
      });
      return cachedUsers;
    })
    .catch((err) => {
      if (err.name === 'AbortError') throw err;
      return [];
    })
    .finally(() => {
      inflightRequest = null;
    });

  return inflightRequest;
}

export function clearUsersListCache() {
  cachedUsers = null;
}
